jQuery(document).ready(function($) {

    $('#nav-toggle').click(function(){

        if ( $('#primary-menu').hasClass('visible') ) {
            $('#primary-menu').removeClass('visible');
            $(this).removeClass('active');
        } else {
            $('#primary-menu').addClass('visible');
            $(this).addClass('active');
        }

    });

    // hide nav if click elsewhere
    $('body').click(function(e) {
        if ($(e.target).closest('#nav-toggle').length === 0 && $(e.target).closest('#primary-menu').length === 0 ) {
            $('#primary-menu').removeClass('visible');
            $('#nav-toggle').removeClass('active');            
        }
    });

    // function stop(e){
    //     e.preventDefault();
    // }
    // $('.menu-title>a').click(function(e){stop(e)});
    // $('.menu-item-has-children>a').click(function(e){stop(e)});


    // =================
    // search
    // =================

    $('#header-search').click(function(){
        var searchForm = $('.search-wrapper');
        var searchVisible = searchForm.hasClass('visible');
        if (searchVisible == true) {
            searchForm.removeClass('visible');
        } else {
            searchForm.addClass('visible');
        }
    });

    $('body').click(function(e) {
        if ($(e.target).closest('.search-wrapper').length === 0 && $(e.target).closest('#header-search').length === 0 ) {
            $('.search-wrapper').removeClass('visible');
        }
    });

    // =================
    // mobile menu items
    // =================

    $('.no-link>a').click(function(e){
        
        e.preventDefault();
    });


    $('.menu-item-has-children').click(function(){

        var ul = $(this).find('.submenu');
        $(this).toggleClass('active');
        ul.toggleClass('visible');
    });

});